import React, { useState, useRef, useEffect } from "react";
import * as S from "./styles";
import { CardProps, removeLengthMinCardId, removeRequiredCardId, SectionProps } from "../../store";
import PreviewCard from "../PreviewCard";
import { useDispatch } from "react-redux";
import { useFormContext } from "react-hook-form";

const Section = ({
  section,
  closedCardIds,
  setClosedCardIds,
  clickSubmit,
  email,
}: {
  section: SectionProps;
  closedCardIds: string[];
  setClosedCardIds: (ids: string[]) => void;
  clickSubmit: boolean;
  email: string;
}) => {
  const isAddable = section.teamNumber !== undefined && section.teamNumber > 0;

  const [visibleTeams, setVisibleTeams] = useState<boolean[]>(
    Array(section.teamNumber || 1).fill(false),
  );
  const [heights, setHeights] = useState<number[]>([]);

  const refs = useRef<(HTMLDivElement | null)[]>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const calculatedHeights = refs.current.map((ref) => (ref ? ref.scrollHeight : 0));
    setHeights(calculatedHeights);
  }, []);

  // 제출될 때 다시 계산
  useEffect(() => {
    const calculatedHeights = refs.current.map((ref) => (ref ? ref.scrollHeight : 0));
    setHeights(calculatedHeights);
  }, [clickSubmit]);

  const toggleVisibility = (index: number) => {
    console.log("closedCardIds", closedCardIds);

    setVisibleTeams((prevVisibleTeams) =>
      prevVisibleTeams.map((visible, i) => {
        if (i === index) {
          // visible이 true면 removeClosedCardId 호출, false면 addClosedCardId 호출
          if (!visible) {
            console.log("removeClosedCardId", index);
            removeClosedCardId(index);
          } else {
            console.log("addClosedCardId", index);
            addClosedCardId(index);
          }
          return !visible;
        }
        return visible;
      }),
    );
  };

  const addClosedCardId = (index: number) => {
    const relatedCardIds = section.cards
      .slice(
        index * Math.ceil(section.cards.length / section.teamNumber!),
        (index + 1) * Math.ceil(section.cards.length / section.teamNumber!),
      )
      .map((card) => card.id);

    setClosedCardIds([...closedCardIds, ...relatedCardIds]);
    removeAllAnswerAndValidation(index);
  };

  const removeClosedCardId = (index: number) => {
    const relatedCardIds = section.cards
      .slice(
        index * Math.ceil(section.cards.length / section.teamNumber!),
        (index + 1) * Math.ceil(section.cards.length / section.teamNumber!),
      )
      .map((card) => card.id);

    setClosedCardIds(closedCardIds.filter((id) => !relatedCardIds.includes(id)));
  };

  const removeAllAnswerAndValidation = (index: number) => {
    const relatedCardId = section.cards
      .slice(
        index * Math.ceil(section.cards.length / section.teamNumber!),
        (index + 1) * Math.ceil(section.cards.length / section.teamNumber!),
      )
      .map((card) => card.id);

    // eslint-disable-next-line no-restricted-syntax
    for (const cardId of relatedCardId) {
      dispatch(removeRequiredCardId({ cardId }));
      dispatch(removeLengthMinCardId({ cardId }));
    }
  };

  return (
    <S.Container>
      <S.Section>
        {section.isTitle ? (
          <img
            src={section.sectionTitle}
            style={{
              width: "calc(100% - 20px)",
              height: "auto",
              padding: 0,
              borderRadius: "8px 8px 0 0",
              margin: "0 auto -10px auto",
              zIndex: 21,
            }}
            alt="헤더이미지"
          />
        ) : null}

        {!section.isTitle ? <S.SectionTitle>{section.sectionTitle}</S.SectionTitle> : null}
        <div
          style={{
            borderRadius: "8px",
          }}
        >
          {isAddable &&
            Array.from({ length: section.teamNumber || 1 }).map((_, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <React.Fragment key={`team-${i}`}>
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <span
                  style={{
                    cursor: "pointer",
                    color: "blue",
                    padding: "10px 0 0px 20px",
                    marginBottom: "10px",
                    display: "inline-block", // 또는 "block"
                  }}
                  onClick={() => toggleVisibility(i)}
                >
                  {!visibleTeams[i] ? ` + 팀원${i + 1} 추가하기` : ` - 팀원${i + 1} 추가 취소하기`}
                </span>
                <S.CardsWrapper
                  ref={(el) => {
                    refs.current[i] = el;
                    return null; // 명시적으로 null을 반환
                  }}
                  style={{
                    height: visibleTeams[i] ? `${heights[i]}px` : "0",
                    opacity: visibleTeams[i] ? "1" : "0",
                  }}
                >
                  {section.cards
                    .slice(
                      i * Math.ceil(section.cards.length / section.teamNumber!),
                      (i + 1) * Math.ceil(section.cards.length / section.teamNumber!),
                    )
                    .map((card, cardIndex) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <PreviewCard key={`${card.id}-${cardIndex}`} id={card.id} email={email} />
                    ))}
                </S.CardsWrapper>
              </React.Fragment>
            ))}
        </div>

        {!isAddable &&
          section.cards.map((card) => <PreviewCard key={card.id} id={card.id} email={email} />)}
      </S.Section>
    </S.Container>
  );
};

export default Section;
